export default "__VITE_ASSET__bc6bce65__"